import { render, staticRenderFns } from "./TaskChild.vue?vue&type=template&id=b78b5a78&"
import script from "./TaskChild.vue?vue&type=script&lang=js&"
export * from "./TaskChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports